import {AnyAction} from "redux";
import {SET_MODAL} from "../actions/action";

export const MODALS =
    {
        TIMER_START: 'TIMER_START',
        POWER_SOURCE_DETAILS: 'POWER_SOURCE_DETAILS',
        EVENT: 'EVENT_DETAILS',
        MINI_GAME_INTRO: 'MINI_GAME_INTRO',
        MINI_GAME_OUTRO: 'MINI_GAME_OUTRO',
        OUTAGE: 'OUTAGE',
        YEAR: 'YEAR',
        SEASON: 'SEASON',
        HINT: 'HINT',
        OUTAGE_QUESTION: 'OUTAGE_QUESTION',
        YEAR_END_STATUS: 'YEAR_END_STATUS',
        YEAR_END_QUESTION: 'YEAR_END_QUESTION',
        MINI_GAME_END_QUESTION: 'MINI_GAME_END_QUESTION',
        GAME_OVER: 'GAME_OVER'
    };


//  define selectors

export const getActiveModal = state => state.modal;



//  define the initial state

const initialState: string = null;


/**
 * reducer: set the current modal ID
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function modal(state: string = initialState, action: AnyAction): string
{
    switch (action.type)
    {
        case SET_MODAL:
        {
            const {payload} = action;
            const {modal_id} = payload;

            return modal_id;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/modal.ts